import React from 'react';
import { Bar, HorizontalBar } from 'react-chartjs-2';
import {
  ChartGrid,
  ChartCard,
  ChartTitle,
  ChartSplitContainer,
  ChartMainContent,
  ChartInfoText
} from '../styles';

interface ChartsSectionProps {
  isLoading: boolean;
  bondInsuranceData: any;
  capitalizationContractsData: any;
  fireInsuranceData: any;
  bondInsurancePerformanceData: any;
  capitalizationPerformanceData: any;
  fireInsurancePerformanceData: any;
  options: any;
  optionsHorizontal: any;
}

const ChartsSection: React.FC<ChartsSectionProps> = ({
  isLoading,
  bondInsuranceData,
  capitalizationContractsData,
  fireInsuranceData,
  bondInsurancePerformanceData,
  capitalizationPerformanceData,
  fireInsurancePerformanceData,
  options,
  optionsHorizontal
}) => {
  return (
    <>
      {/* Primeira linha de gráficos */}
      <ChartGrid>
        <ChartCard>
          <ChartTitle>Apólices - Fiança {isLoading && '(Carregando...)'}</ChartTitle>
          <Bar data={bondInsuranceData} options={options} />
        </ChartCard>

        <ChartCard>
          <ChartTitle>
            Contratos - Capitalização {isLoading && '(Carregando...)'}
          </ChartTitle>
          <Bar data={capitalizationContractsData} options={options} />
        </ChartCard>

        <ChartCard>
          <ChartTitle>Orçamentos - Incêndio {isLoading && '(Carregando...)'}</ChartTitle>
          <Bar data={fireInsuranceData} options={options} />
        </ChartCard>
      </ChartGrid>

      {/* Segunda linha de gráficos */}
      <ChartGrid>
        <ChartCard>
          <ChartTitle>Desempenho geral - Fiança</ChartTitle>
          <ChartSplitContainer>
            <ChartMainContent>
              <ChartInfoText> Apólices emitidas</ChartInfoText>
              <HorizontalBar
                data={bondInsurancePerformanceData}
                options={optionsHorizontal}
                height={160}
              />
            </ChartMainContent>
          </ChartSplitContainer>
        </ChartCard>

        <ChartCard>
          <ChartTitle>Desempenho geral - Capitalização</ChartTitle>
          <ChartSplitContainer>
            <ChartMainContent>
              <ChartInfoText> Contratos</ChartInfoText>
              <HorizontalBar
                data={capitalizationPerformanceData}
                options={optionsHorizontal}
                height={160}
              />
            </ChartMainContent>
          </ChartSplitContainer>
        </ChartCard>

        <ChartCard>
          <ChartTitle>Desempenho geral - Incêndio</ChartTitle>
          <ChartSplitContainer>
            <ChartMainContent>
              <ChartInfoText> Orçamentos</ChartInfoText>
              <HorizontalBar
                data={fireInsurancePerformanceData}
                options={optionsHorizontal}
                height={160}
              />
            </ChartMainContent>
          </ChartSplitContainer>
        </ChartCard>
      </ChartGrid>
    </>
  );
};

export default ChartsSection;
